import { EnvironmentType } from '@/shared/lib';

import type {
  Context,
  Plugin,
} from '@nuxt/types';
import type { Inject } from '@nuxt/types/app';
import type { NuxtAxiosInstance } from '@nuxtjs/axios';

declare module '@nuxt/types' {
  interface Context {
    $portalApi?: NuxtAxiosInstance;
  }

  interface NuxtAppOptions {
    $portalApi?: NuxtAxiosInstance;
  }

  interface Configuration {
    portalApi?: NuxtAxiosInstance;
  }
}

declare module 'vue/types/vue' {
  interface Vue {
    $portalApi?: NuxtAxiosInstance;
  }
}

let portalApiInstance: NuxtAxiosInstance | undefined;

const portalApiPlugin: Plugin = (ctx: Context, inject: Inject) => {
  const {
    $config,
    $axios,
  } = ctx;

  const API_PATH = '';
  let API_URL;

  const addHttps = (url: string) => url.startsWith('https://') ? url : `https://${ url }`;

  if ($config.ENVIRONMENT === EnvironmentType.Local) {
    API_URL = process.client ? location.origin : addHttps($config.MAIN_SITE_HOST);
  } else {
    API_URL = addHttps($config.MAIN_SITE_HOST);
  }

  API_URL += API_PATH;
  portalApiInstance = $axios.create({
    baseURL: API_URL,
    headers: {
      platform: 'Broker',
    },
  });

  inject('portalApi', portalApiInstance);
  ctx.$portalApi = portalApiInstance;
};

export default portalApiPlugin;

export const usePortalApi = () => {
  if (!portalApiInstance) {
    throw new Error('Portal API instance is not defined :(');
  }

  return portalApiInstance;
};
